<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="col-12 pb-5 mb-4" v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-3 middle-background"></div>
        <div class="col-md-12 col-lg-6 middle-background main-card">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters mt-5">
            <div class="col-lg-12">
              <div class="row no-gutters">
                <br />
              </div>
              <div class="col-lg-12">
                <div class="row no-gutters  " @click="previous">                  
                    <img src="../assets/Back.svg" class="img-fluid mr-1" alt="back" />
                    <label class="ml-2 fontsize12 proximanova-bold black prof-details hover">Profile Details</label>                  
                </div>
              </div>
              <div class="card card1 ml-3 mr-3 mt-lg-2">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-2 col-md-2 pr-0 pr-lg-2 col-2">
                      <!-- <img v-if="!profilePicLink" class="img-fluid" src="../assets/Profile_placehlder.svg" /> -->
                      <div v-if="!profilePicLink" id="profImage1" class=" text-center mt-0 mt-md-2 pointer rounded-circle white" :class="firstname.charAt(0)">
                            <span class="white fontsize17 text-uppercase">{{firstname.charAt(0)}}</span>
                          </div>
                      <div v-else class="profile-pic" >
                        <div class="profile-border">
                          <img :src="profilePicLink" @error="profilePicLink = null" class="img-fluid rounded-circle loadingBgImg" alt="profilepic" id="profImage">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-10 col-md-10 col-10 nameblock">
                      <div class="float-right proximanova-semibold fontsize16 black60  hover d-flex">
                        <span class="my-auto" v-if="this.profileId !== null && this.profileId !== undefined "  id="follow">
                          <button @click="followUser" :disabled="disablefollowBtn" v-if="followingTest === 'Follow'" class="bordernone backgroundnone fontsize16 black60 proximanova-semibold pointer">{{followingTest}}</button>
                          <button @click="UnfollowUser" :disabled="disablefollowBtn" v-if="followingTest === 'UnFollow'" class="bordernone backgroundnone fontsize16 black60 proximanova-semibold hover">{{followingTest}}</button>
                        </span>
                        <div class="ml-1">
                          <span class="" >
                            <img src="../assets/horizontal_menu_icon.svg" v-popover:selecteduser width="20px" id="selectedusermore" class="img-fluid float-right mr-2 mt-1 menuicon moreactionsmenu" alt="moremenu">
                          </span>
                          <popover name="selecteduser" class="welcomemenu">
                            <div class="p-2">
                                <div class="d-flex p-1 justify-content-between">
                                  <span class="fontsize12 proximanova-bold black">More Actions</span>
                                  <div class="closebtnmouseover">
                                    <img src="../assets/Close1.svg" class="img-fluid pr-1 closebtn" alt="closebtn" @click="closeMoreActions">
                                  </div>
                                </div>
                                <!-- <div class="d-flex p-1 action" id="onclickshare">
                                    <img src="../assets/Hide.svg" class="img-fluid pl-1 pr-1 " alt="hide">
                                    <span class="pt-2 pl-2 d-flex flex-column">
                                      <div class="fontsize14 black80 proximanova">Block Profile</div>
                                      <div class="fontsize12 black60 proximanova">No longer connected</div> 
                                    </span>
                                </div> -->
                                <div class="d-flex p-1 action" @click="getReportprofile()">
                                    <img src="../assets/Report.svg" class="img-fluid pl-1 pr-1" alt="report">
                                    <span class="pt-2 pl-2 d-flex flex-column">
                                      <div class="fontsize14 black80 proximanova">Report Profile</div>
                                      <div class="fontsize12 black60 proximanova">This profile is not relevent and offencive</div>  
                                    </span>
                                </div>
                            </div>
                          </popover>
                        </div>
                      </div>
                      <div class="fontsize32 proximanova black ml-1 pt-2 welcomename" >{{firstname}} {{lastname}}</div>                      
                      <div class="d-md-flex pl-1 text-capitalize proximanova fontsize16 black60">
                        <div v-if="usercompany">{{usercompany}}</div>
                        <div v-if="userdesignation" class="verticaline ml-2 mr-2 d-none d-md-block"> | </div>
                        <div v-if="userdesignation">{{userdesignation}}</div>
                        <div v-if="userdisplayCountry" class="verticaline ml-2 mr-2 d-none d-md-block"> | </div>
                        <div v-if="userdisplayCountry">{{userdisplayCountry}}</div>
                      </div>
                      <!-- <div v-if="aboutYou1" class="d-flex flex-nowrap ml-1 pr-1"> -->
                      <div v-if="totalDescription" class="d-flex flex-nowrap ml-1 pr-1">
                        <div class="fontsize16 black60 proximanova">
                          {{totalDescription}}
                          <!-- <span @click="readmore()" v-if="totalDescription.length > 124"><span v-if="!readmoreclicked" class="fontsize14 blue pointer">...readmore</span></span><span class="fontsize14 blue pointer" v-if="readmoreclicked" @click="readless()">...readless</span> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">                    
                    <div class="mt-3 count">
                      <div class="row">
                        <div class="col-2">
                          <label class="mr-5 proximanova-semibold fontsize14 black60">Posts</label>
                          <label v-if="postsCount > 0" class="proximanova fontsize20 black60 "  id="follower">{{postsCount}}</label>
                          <label class="proximanova fontsize20 black60 "  v-else>00</label>
                        </div>
                        <div class="col-2">
                          <label class="mr-5 proximanova-semibold fontsize14 black60">Followers</label>
                          <label v-if="followersCount > 0" class="proximanova fontsize20 black60 "  id="follower">{{followersCount}}</label>
                          <label class="proximanova fontsize20 black60 "  v-else>00</label>
                        </div>
                        <div class="col-2 ml-4">
                          <label class="proximanova-semibold fontsize14 black60">Following</label>
                          <label v-if="followingCount > 0" class="proximanova fontsize20 black60 "  id="follower">{{followingCount}}</label>
                          <label class="proximanova fontsize20 black60 "  v-else>00</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="line" v-if="jobchange == 'Y'"></div>
                  <div class="row" v-if="jobchange == 'Y'">
                    <div class="col d-flex justify-content-center">
                      <div class="fontsize16 black60 proximanova mt-2 ml-1 mr-1 ">
                        I am actively looking for job change                        
                      </div>
                      <a class="border-color fontsize14 black80 proximanova-bold mt-1 p-1 pl-2 pr-2 backgroundcolor5 borderradius5">Hire me</a>
                    </div>
                  </div>
                </div>
              </div>
              <nav class="nav ml-3 mr-3">
                <div class="col-12 card-header mt-3 mt-lg-4 mb-3">
                  <div class="row no-gutters">
                    <ul class="nav nav-tabs proximanova-bold blue fontsize12">
                      <li class="nav-item mr-lg-3 mr-md-3 mouseoveraction">                        
                        <a
                          :class="{'proximanova-semibold blue border-tab':activeClass == 'video_profile'}"
                          id="video_profile"
                          @click="toggleActiveClass('video_profile')"
                        >Video Profile</a>
                      </li>
                      <li class="nav-item mr-lg-3 mr-md-3 mouseoveraction">                        
                        <a
                          :class="{'proximanova-semibold blue border-tab':activeClass == 'profile_details'}"
                          id="profile_details"
                          @click="toggleActiveClass('profile_details')"
                        >Profile Details</a>
                      </li>
                      <li class="nav-item mouseoveraction">                        
                        <a
                          :class="{'proximanova-semibold blue border-tab':activeClass == 'my_videos'}"
                          id="my_videos"
                          @click="toggleActiveClass('my_videos')"
                        >Videos</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
              <div v-show="showprofiledetails">
                <div class="row no-gutters ml-3 mr-3" v-if=" workExperience.length ===0 && educationList.length === 0 &&  !userZipcode && userKnowledgeList.length === 0">
                  <div class="col-12 mb-3">
                    <div class="card" >
                      <div class="mt-3 mb-3 ml-3 mr-auto">
                        <span class="proximanova-bold fontsize16 black60">No Details Found</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters ml-3 mr-3"  v-if="workExperience.length > 0">
                  <div class="col-12 mb-3">
                    <div class="card">
                      <div class="row">
                        <div class="col d-flex">
                          <div class="mt-3 mb-3 ml-3 mr-auto">
                            <label class="proximanova-bold fontsize16 black60 label-bottom">Work Experience</label>
                          </div>                                                   
                        </div>
                      </div>
                      <div v-if="workExperience.length > 0" class="pb-3">
                        <div v-for="(exp, index) in workExperience" :key="index">
                          <div class="col d-flex mb-4">
                            <div class="">
                              <img src="../assets/Company_Icon.svg" alt="companyicon" class="img-fluid p-1 rounded-circle border compIcon">
                            </div>
                            <div class="col-10">
                              <div class="fontsize14 proximanova-semibold black text-capitalize">
                                {{exp.companyDetails.companyName}}
                              </div>
                              <div class="fontsize14 black80 proximanova text-capitalize">
                                {{exp.userRoles.roleName}} - {{exp.employeementTypeString}}
                              </div>
                              <div class="d-flex expDetails proximanova-semibold fontsize12 black30">
                                <div v-if="exp.startDate">{{exp.startDate | moment("MMM YYYY") }}</div> <span class="pl-lg-2 pr-lg-2 pr-1 pl-1"> - </span> 
                                <div v-if="exp.endDate">{{exp.endDate | moment("MMM YYYY")}}</div>
                                <div v-if="exp.currentWorkingFlag == 'Y'">Present</div> <span class="pr-lg-2 pr-1"> , </span>
                                <div v-if="exp.totalExperience && exp.currentWorkingFlag == 'N'">{{exp.totalExperience}}</div>
                                <div v-else>{{new Date(exp.startDate) | moment("from", "now", true)}}</div>
                              </div>
                              <div class="proximanova-semibold fontsize12 black30 text-capitalize d-flex">
                                <span v-if="exp.city" class="mr-1">{{exp.city.cityName}} ,</span><span v-if="exp.country">{{exp.country.countryName}}</span>
                              </div>
                              <div v-if="exp.description" class="d-flex flex-nowrap mt-2">
                                <div class="fontsize14 black80 proximanova ">
                                  <span :id="'totaldescription'+index">{{exp.description1}}</span>                                  
                                  <span class="readmore readmorelink" :id="'readmore'+index" v-if="exp.description2.length>0" @click="readMoreExp">...readmore</span>
                                  <span class="readmore readlesslink" :id="'readless'+index" @click="readLessExp">...readless</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters ml-3 mr-3" v-if="educationList.length > 0">    
                  <div class="col-12 mb-3">
                    <div class="card"> 
                      <div class="row">
                        <div class="col d-flex">
                          <div class="mt-3 mb-3 ml-3 mr-auto">
                            <label class="proximanova-bold fontsize16 black60 label-bottom">Highest Education</label>
                          </div>                          
                        </div>
                      </div>
                      <div v-if="educationList.length > 0" class="pb-3">
                        <div v-for="(edu, index) in educationList" :key="index">
                          <div class="col d-flex mb-4">
                            <div class="">
                              <img src="../assets/Company_Icon.svg" alt="companyicon" class="img-fluid p-1 rounded-circle border compIcon">
                            </div>
                            <div class="col-10">
                              <div class="fontsize14 proximanova-semibold black text-capitalize">
                                {{edu.instituteDetails.instituteName}}
                              </div>
                              <!-- <div class="fontsize14 black80 proximanova">
                                {{edu.typeOfDegreeString}}
                              </div> -->
                              <div class="fontsize14 black80 proximanova">
                                {{edu.fieldOfStudy.fieldName}}
                              </div>
                              <div class="d-flex educationDetails proximanova-semibold fontsize12 black30">
                                <div v-if="edu.fromDate">{{edu.fromDate | moment("MMM YYYY") }}</div> <span class="pl-lg-2 pr-lg-2 pl-1 pr-1"> - </span> 
                                <div v-if="edu.toDate">{{edu.toDate | moment("MMM YYYY")}}</div>
                                <div v-if="edu.currentStudyFlag == 'Y'"> Present</div> <span class="pr-lg-2 pr-1"> , </span>
                                <div v-if="edu.educationDuration">{{edu.educationDuration}}</div>
                                <div v-else>{{new Date(edu.fromDate) | moment("from", "now", true)}}</div>
                              </div>
                              <div class="proximanova-semibold fontsize12 black30 text-capitalize d-flex">
                                <span v-if="edu.city" class="mr-1">{{edu.city.cityName}} , </span> <span v-if="edu.country">{{edu.country.countryName}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters ml-3 mr-3" v-if="userZipcode">
                  <div class="col-12 mb-3">
                    <div class="card" > 
                      <div class="row">
                        <div class="col d-flex">
                          <div class="mt-3 mb-3 ml-3 mr-auto">
                            <label class="proximanova-bold fontsize16 black60 label-bottom">Location</label>
                          </div>                          
                        </div>
                      </div>
                      <div class="pb-3" v-if="userZipcode">
                        <div class="col d-flex mb-3">
                          <div class="">
                            <img src="../assets/Company_Icon.svg" alt="companyicon" class="img-fluid p-1 rounded-circle border compIcon">
                          </div>
                          <div class="col-10">
                            <div class="fontsize14 proximanova-semibold black text-capitalize">
                              {{userCountry.countryName}}
                            </div>
                            <div class="fontsize14 black80 proximanova">
                              {{userState.stateName}}
                            </div>
                            <div class="proximanova-semibold fontsize12 black30">
                              {{userCity.cityName}} , {{userZipcode}}
                            </div>                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters ml-3 mr-3" v-if="userKnowledgeList.length > 0">
                  <div class="col-12 mb-3">
                    <div class="card pb-4" >
                      <div class="row">
                        <div class="col d-flex">
                          <div class="mt-3 mb-3 ml-3 mr-auto">
                            <label class="proximanova-bold fontsize16 black60 label-bottom">Skills</label>
                          </div>    
                        </div>
                      </div>
                      <div v-if="userKnowledgeList.length > 0" class="col">
                        <span class="proximanova fontsize14 black60 mb-3">Knowledge In</span>
                        <div class="d-flex flex-wrap">
                          <div v-for="(skill, index) in userKnowledgeList" :key="index" >
                            <div class="pl-2 pr-4 pt-1 pb-1 mr-2 mb-1 knowledgeItem d-flex mt-1 black60 proximanova fontsize12">
                              {{skill.knowledgeDetails.knowledgeIn}}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="userTechnologyList.length > 0" class="col mt-2 pb-4">
                        <span class="proximanova fontsize14 black60 mb-2">Tools</span>
                        <div class="d-flex flex-wrap">
                          <div v-for="(technology, index) in userTechnologyList" :key="index" >
                            <div class="pl-2 pr-4 pt-1 pb-1 mr-2 knowledgeItem d-flex mt-1 black60 proximanova fontsize12">
                              {{technology.technologyDetails.technologyName}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="showvideoprofile">
                <div>
                  <div v-if="!savedProfileVideoLink" class="card mr-2 ml-3 mr-3 mb-4">
                    <div class="card-body text-center pt-5 pb-5">
                        <div class="p-5 d-flex flex-column">
                           <img src="../assets/no_video.svg" alt="novideo" class="img-md-fluid img-sm-fluid no-video pl-5 pr-5 pb-4">
                          <!--<span class="oops">Oops!</span> -->
                          <span class="proximanova-thin fontsize24 black60">User haven't posted Profile Video</span>
                        </div>
                    </div>
                  </div>   
                  <div class="card videocard mr-2 ml-3 mr-3 mb-4 overlay-gradient"  v-else>
                    <div>
                      <video controlsList="nodownload" height="280" oncontextmenu="return false;" preload="metadata"   id="profilevideo" :src="savedProfileVideoLink"  :ref="'video'" >                        
                      </video>                      
                    </div>
                    <div class="card-img-overlay ">
                      <div class="row mb-3 ml-0 mr-0 black_overlay1">
                          <div class="col ml-0 mt-3 d-flex ">                            
                            <div class="d-flex flex-column">                              
                              <span class="ml-2 mr-2 proximanova-semibold white fontsize14 bold14px_white">Created On : {{savedProfileVideoDate | moment("ll") }}</span>
                            </div>
                          </div>
                      </div>
                      <div class="text-center mt-3">
                          <img src="../assets/play_video.svg" id="playvideobtn" v-if="!playingPorfileVideo" alt="playvideo" @click="playPorfileVideo">
                          <div class="replaybtn additionalStyles shadow" title="replay video" id="playvideobtn" v-if="playingPorfileVideo && replayPorfileVideo">
                            <img src="../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo()">
                          </div>
                          <div class="replaybtn1 additionalStyles shadow" title="replay video" id="playvideobtn" v-if="playingPorfileVideo && loadingPorfileVideo">
                            <img src="../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
                          </div>
                          <img src="../assets/Pausevideo.svg"  class=" pausebtn" :class="{'display-button': playingPorfileVideo}" v-if="playingPorfileVideo && !replayPorfileVideo && !loadingPorfileVideo" id="playvideobtn"  alt="pausevideo" @click="playPorfileVideo">          
                      </div>
                      <div id="bottom">
                          <div class="black_overlay2">
                            <div class="pb-3 d-flex flex-column p-3">
                              <span v-if="savedProfileVideoTitle" class="bold16px_white fontsize16 white proximanova-semibold text-capitalize">{{savedProfileVideoTitle}}</span>
                              <span v-if="savedProfileVideoDescription" class="reg16px_white proximanova fontsize16 white60 text-capitalize">{{savedProfileVideoDescription}}</span>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                                     
                </div>
              </div>
              <div v-show="showvidoes">
                <div class="row no-gutters ml-3 mr-3">
                  <div class="col-12 mb-3">
                    <!-- POSTED VIDEOS TAB -->
                    <div v-if="postedVideosTab">
                      <div class="col-12 pb-5 mb-4" v-if="contentloader">
                        <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
                      </div>
                      <div v-if="!contentloader">
                        <div class="card" v-if="postedVideosList.length<1">
                          <div class="card-body text-center pt-5 pb-5">
                            <div class="p-5 d-flex flex-column text-center">
                              <img src="../assets/no_video.svg" class="img-md-fluid img-sm-fluid no-video pl-5 pr-5 pb-4" alt="novideo">
                              <span class="proximanova-thin fontsize24 black60">User haven't posted any Videos</span>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-for="(videoitem, index) in postedVideosList" :key="index">
                            <div class="card mb-2" :id="'selectedUserVideoCardItem'+index">
                              <div class="card-body postedvideoslist">
                                <div class="d-flex flex-column">
                                  <div class="videocardhead d-flex justify-content-between p-3">
                                    <div class="d-flex">
                                      <div class="postvideoimage pl-1">
                                        <img v-if="profilePicLink" :src="profilePicLink" @error="profilePicLink = null" alt="profilepic" class="rounded-circle border border-secondary loadingBgImg" width="40px">
                                        <!-- <img v-else  src="../assets/Profile_placehlder.svg" class="rounded-circle border border-secondary" width="40px" alt=""> -->
                                        <div id="profImage2" class=" text-center pointer rounded-circle white" :class="firstname.charAt(0)" v-else>
                                          <span class="white fontsize16 text-uppercase">{{firstname.charAt(0)}}</span>
                                        </div>
                                      </div>
                                      <div class="d-flex flex-column pl-2 pr-2 mt-0">
                                        <span class="fontsize14 proximanova-semibold black">{{firstname}} {{lastname}}</span>
                                        <span class="proximanova black80 fontsize12">{{userdesignation}}-{{userCountry.countryName}}</span>
                                      </div>
                                      <div class="proximanova black80 fontsize12 pt-1 ml-3">
                                        <span v-if="videoitem.creationD !== null && videoitem.lastUpdatedD == null">{{new Date(videoitem.creationD) | moment("from", "now", true)}} ago</span>
                                        <span v-else>{{new Date(videoitem.lastUpdatedD) | moment("from", "now", true)}} ago</span>
                                      </div>
                                    </div>                                    
                                  </div>
                                  <div class="videocardbody">                                    
                                    <span v-if="videoitem.aspectRatio">
                                      <span v-if="videoitem.aspectRatio < 1">
                                        <video controlsList="nodownload" controls muted oncontextmenu="return false;" :src="videoitem.videoLink" class="postedvideoItem portraitvideheight" @loadedmetadata="videoMetaLoadedPosted(index,videoitem.id)" @error ="videoLoadingPosted(index)"  @pause="VideoPause(videoitem,index,'posted')" v-on:play="VideoPlay(videoitem,index,'posted')" :id="'postvideo'+index" preload="metadata">
                                          <!-- <source :src="videoitem.videoLink"> -->
                                        </video>
                                      </span>
                                      <span v-if="videoitem.aspectRatio >1">
                                        <video controlsList="nodownload" controls muted  oncontextmenu="return false;" :src="videoitem.videoLink" class="postedvideoItem" @error ="videoLoadingPosted(index)" @loadedmetadata="videoMetaLoadedPosted(index,videoitem.id)" @pause="VideoPause(videoitem,index,'posted')" v-on:play="VideoPlay(videoitem,index,'posted')" :id="'postvideo'+index" preload="metadata">
                                          <!-- <source :src="videoitem.videoLink"> -->
                                        </video>
                                      </span>
                                      <span v-if="videoitem.aspectRatio =1">
                                        <video controlsList="nodownload" controls muted  oncontextmenu="return false;" :src="videoitem.videoLink" class="postedvideoItem" @error ="videoLoadingPosted(index)" @loadedmetadata="videoMetaLoadedPosted(index,videoitem.id)" @pause="VideoPause(videoitem,index,'posted')" v-on:play="VideoPlay(videoitem,index,'posted')" :id="'postvideo'+index" preload="metadata">
                                          <!-- <source :src="videoitem.videoLink"> -->
                                        </video>
                                      </span>
                                    </span>
                                    <span v-else>
                                      <video controlsList="nodownload" height="400px" controls muted oncontextmenu="return false;" :src="videoitem.videoLink" class="postedvideoItem" @error ="videoLoadingPosted(index)" @loadedmetadata="videoMetaLoadedPosted(index,videoitem.id)" @pause="VideoPause(videoitem,index,'posted')" v-on:play="VideoPlay(videoitem,index,'posted')" :id="'postvideo'+index" preload="metadata">
                                        <!-- <source :src="videoitem.videoLink"> -->
                                      </video>
                                    </span>                                    
                                  </div>
                                  <div class="postvideocontent p-1 pb-2 pl-3">
                                    <div class="d-flex flex-column pl-2">
                                      <span class="proximanova-bold fontsize16 black80">{{videoitem.videoTitle}}</span>
                                      <span class="proximanova fontsize14 black60">{{videoitem.videoDescription}}</span>
                                    </div>
                                  </div>
                                  <div class="horizonline"></div>
                                  <div class="d-flex p-3">
                                    <div class="d-flex ml-2">
                                      <img src="../assets/Like.svg" alt="like" class="postvideoIcons" v-if="videoitem.likeVideoFlag == 'N'" @click="LikePostedVideo(index, videoitem.id, videoitem.profileId, 'posted')">
                                      <img src="../assets/Likedblue.svg" alt="unlike" class="postvideoIcons" v-if="videoitem.likeVideoFlag == 'Y'" @click="unlikePostedVideo(index, videoitem.id, 'posted')">
                                      <span class="profiledetails  fontsize12 proximanova  black60 pt-1 ml-2" v-if="videoitem.noOfLikes>0">{{videoitem.noOfLikes}}</span>
                                      <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-else>00</span>
                                    </div>
                                    <div class="d-flex ml-lg-5 ml-4">
                                      <img src="../assets/Comment.svg" alt="comment" v-if="videoitem.commentVideoFlag == 'N'" class="postvideoIcons">
                                      <img src="../assets/Commentblue.svg" alt="comment" v-if="videoitem.commentVideoFlag == 'Y'" class="postvideoIcons">
                                      <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-if="videoitem.noOfComments>0">{{videoitem.noOfComments}}</span>
                                      <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-else>00</span>
                                    </div>
                                    <div class="d-flex ml-lg-5 ml-4" @click="ShareVideoModal(videoitem, 'posted')">
                                      <img src="../assets/Share_Video.svg" alt="share" class="postvideoIcons">
                                      <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2">00</span>
                                    </div>
                                    <div class="d-flex ml-lg-5 ml-4">
                                      <img src="../assets/Views.svg" alt="viewvideo" class="postvideoIcons">
                                      <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-if="videoitem.noOfViews>0">{{videoitem.noOfViews}}</span>
                                      <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-else>00</span>
                                    </div>
                                  </div>
                                  <div class="horizonline1"></div>
                                  <div class="commentsection d-flex pt-3 pl-3 pr-3 pb-1">
                                    <div class="postvideoimage pl-2">
                                      <img v-if="currentUserProfilePic" :src="currentUserProfilePic" alt="profilepic" class="rounded-circle loadingBgImg1" width="38px">
                                      <img v-else  src="../assets/Profile_placehlder.svg" width="38px" alt="profilepic">
                                    </div>
                                    <div class="commentssection d-flex">
                                      <input type="text" v-model="videoitem.commentpostText" @keyup="videoitem.postcommentbtn = true" class="commentssectiontext proximanova black60" placeholder="Add my comment...">
                                      <img src="../assets/commentsend.svg" width="30px" v-if="videoitem.postcommentbtn" height="25px" title="post comment" class="postcommenticon ml-1" alt="comment" @click="postComment(index, videoitem, 'posted')">
                                    </div>
                                  </div>
                                  <div v-if="videoitem.listOfComments">
                                      <div v-if="videoitem.listOfComments.length>0">
                                        <div v-for="(comment,cmind) in videoitem.listOfComments" :key="cmind">
                                          <div class="d-flex pt-3 pl-3 pr-3" v-if="cmind < videoitem.limit_by">
                                            <div class="postvideoimage pl-2">
                                              <img v-if="comment.profilePictureLink" :src="comment.profilePictureLink" @error="comment.profilePictureLink = null" alt="profilepic" class="rounded-circle loadingBgImg1" width="38px">
                                              <!-- <img v-else  src="../assets/Profile_placehlder.svg" width="38px" alt=""> -->
                                              <div id="profImage2" class=" text-center pointer rounded-circle white" :class="comment.firstName.charAt(0)" v-else>
                                                <span class="white fontsize16 text-uppercase">{{comment.firstName.charAt(0)}}</span>
                                              </div>
                                            </div>
                                            <div v-if="currentUserProfileId !== comment.profileId" class="commentssectiontext2 pl-3 p-2">
                                              <div class="d-flex flex-column">
                                                <span class="fontsize12 proximanova-bold black">{{comment.firstName}} {{comment.lastName}}</span>
                                                <span class="proximanova black80 fontsize12">{{comment.designationName}}, {{comment.country}}</span>
                                              </div>
                                              <span class="proximanova black60  fontsize14">{{comment.comment}}</span>
                                            </div>
                                            <div v-else class="commentssectiontext2 pl-3 p-2">
                                              <div class="d-flex justify-content-between">
                                                <div class="d-flex flex-column">
                                                  <span class="fontsize12 proximanova-bold black">{{comment.firstName}} {{comment.lastName}}</span>
                                                  <span class="proximanova black80 fontsize12">{{comment.designationName}}, {{comment.country}}</span>
                                                </div>
                                                <div>
                                                  <img src="../assets/commentsend.svg" width="28px" height="21px" v-if="comment.iscommentchanged" class="postcommenticon mr-1" title="update comment" alt="comment" @click="updateComment(comment, videoitem)">
                                                  <img src="../assets/Delete_Comment.svg" width="28px" height="22px" class="postcommenticon mt-2 mr-2" alt="delete" title="delete comment" @click="openDeleteCommentConfirmationmodal(cmind, comment, videoitem)">
                                                </div>
                                              </div>
                                              <input type="text" class="commentssectiontext3 proximanova black60  fontsize14" v-model="comment.comment" @keyup="DisplayPostCommentUpdate(comment)">
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    <div class="viewallcomments pl-5 pt-3 pb-3">
                                      <span class="pl-4 ml-3 proximanova black fontsize12" v-if="videoitem.listOfComments.length>0 && videoitem.listOfComments.length > videoitem.limit_by" @click="viewAllComments(index, 'posted')">View all Comments</span>
                                      <span class="pl-4 ml-3 proximanova black fontsize12" v-if="videoitem.listOfComments.length>2 && videoitem.listOfComments.length <= videoitem.limit_by" @click="viewLessComments(index, 'posted')">View less comments</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 pb-5 mb-4" v-if="instanceLoader">
                        <img src="../assets/pageloader.svg" class="instanceloader" alt="loadinganimation">
                      </div>
                    </div>
                  </div>
                </div>
              </div>           
            </div>
          </div>
        </div>
        <sharevideomodal v-if="shareavideomodalopen" :sharevideo="sharevideoobject" @close = "closeshareModal"></sharevideomodal>
        <reportProfileModal  v-if="reportprofilemodal" :reportuser="reportprofileobject" @closereport = "closereportprofileModal"></reportProfileModal>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
        <delete-comment-confirmation-modal :modalTitle="deleteCommentTitle" v-if="deletecommentconfirmationmodalopen" @CloseCommentConfirmationModal = "CloseCommentConfirmationModal"></delete-comment-confirmation-modal>
        <div class="col middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row row no-gutters">
            <br />
          </div>
          <pendingActivities />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sidemenu from "@/components/SideMenu.vue";
import topmenu from "@/components/TopHeader.vue";
import httpuserprofile from "@/js/http-userprofile.js";
import pendingActivities from "../components/PendingActivities.vue";
import Footer from "../components/Footer";
import sharevideomodal from '../components/SharePostModal.vue';
import reportProfileModal from '../components/reportUserModal.vue'
import deleteCommentConfirmationModal from '../components/deleteCommentConfirmModal.vue'
import APIerrorModal from '../components/APIerrorpopup.vue'
import sessionUtils from '@/js/session-util.js'
import $ from "jquery";
export default {
    components: {
    sidemenu,
    topmenu,
    pendingActivities,
    Footer,
    sharevideomodal,
    APIerrorModal,
    deleteCommentConfirmationModal,
    reportProfileModal
  },
  data(){
      return{
        totalvideodata:[],
        selectedUser: '',
        profileId: null,
        firstname: "",
        lastname: "",
        profilePicLink:'',        
        aboutYou : '',
        usercompany: "",
        userdesignation : '',
        totalDescription : '',
        userdisplayCountry : '',
        aboutYou1 : '',
        aboutYou2 : '',
        readmoreclicked : false,
        activeClass: "video_profile",
        showprofiledetails: false,
        showvideoprofile: true,
        showvidoes: false,
        workExperience: [],
        educationList : [],
        userState : {},
        userCity : {},
        userCountry : {},
        userZipcode : '',
        employmentTypeList : [],
        typeOfDegreeList : [],
        userKnowledgeList : [],
        userTechnologyList: [],
        followersCount: null,
        followingCount: null,
        currentUserProfileId: null,
        follwedBy: null,
        followers: [],
        followingTest: 'Follow',
        disablefollowBtn : false,
        jobchange: "N",
        profileVideoLink: '',
        profileVideoThumbNail : '',
        savedProfileVideoDate: '',
        playingPorfileVideo: false,     
        replayPorfileVideo : false,
        loadingPorfileVideo : false,
        savedProfileVideoDescription : null,
        savedProfileVideoDate : null,
        savedProfileVideoTitle : null,
        savedProfileVideoDescription : null,
        savedProfileVideoLink : null,
        savedProfileVideoThumbnailLink : null,
        profileVideoId: null,
        activeVideoClass : 'posts_tab',
        postedVideosTab : true,        
        likedVideosTab : false,
        sharedVideosTab : false,
         getByIdTotalResponse:[],
         postedVideosList: [],
         displayAPIerrorModal : false,
         shareavideomodalopen : false,
         reportprofilemodal : false,
         reportprofileobject : {},
         currentUserId: null,
         currentUserEmail : null,
         currentUser: [],
         currentUserProfilePic: '',
         likedVideosList : [],
         sharedVideosList: [],
         postedvideosoffset : 0,
         likedvideosoffset : 0,
         sharedvideosoffset : 0,
         savedvideosoffset : 0,
         instancedataget : true,
         contentloader : true,
         instanceLoader : false,
         pageloader : true,
         postsCount : null,
         deletecommentconfirmationmodalopen : false,
         selectedVideotodeletecomment : null,
         selectedcommenttodelete : null,
         selectedcommentIndex : null,
         deleteCommentTitle : "Are you sure you want to delete this comment ?",
      }
  },
  watch: {
    '$route.params.id': function (id) {     
      this.selectedUser = id;
      this.resetdata();
      this.getUserByID(id);   
    },    
},
  methods:{
    closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
      },
    resetdata(){
      this.pageloader = true;
      this.workExperience = [];
      this.educationList = [];
          this.profileId = null;         
          //basic info
          this.firstname = "";
          this.lastname = "";
          this.profilePicLink = '';               
          let aboutyou = '';
          this.totalDescription ='';
          this.aboutYou1 = '';
          this.aboutYou2 = '';
          this.savedProfileVideoDate = null
        this.savedProfileVideoLink = null;
        this.savedProfileVideoThumbnailLink = null;
        this.savedProfileVideoTitle =null;
        this.savedProfileVideoDescription = null;
    },
    previous(){
      this.$router.go(-1);
    },
    closeMoreActions : function(){
      document.getElementById('selectedusermore').click()
    },
    getReportprofile(){
      this.reportprofilemodal = true;
      let item = {}
      item.checkobj = "hiphiphurray"
      item.profileId  = this.profileId;
      item.currentUserEmail = this.currentUserEmail
      this.reportprofileobject = item;  
    }, 
    closereportprofileModal(){
      this.reportprofilemodal = false;
    },
    videoMetaLoadedPosted(index,vid){
      var videoElement = document.getElementById("postvideo"+index); 
      if(this.postedVideosList[index].aspectRatio === null && vid === this.postedVideosList[index].id ){
        this.postedVideosList[index].videoWidth = videoElement.videoWidth;
      this.postedVideosList[index].videoHeight = videoElement.videoHeight;
      this.postedVideosList[index].aspectRatio = videoElement.videoWidth/videoElement.videoHeight;
     
      }      
      this.postedVideosList[index].pausefromScroll = true;
    },
    videoMetaLoadedLiked(index,vid){
      var videoElement = document.getElementById("postvideo"+index); 
      if(this.likedVideosList[index].aspectRatio === null && vid === this.likedVideosList[index].id ){
        this.likedVideosList[index].videoWidth = videoElement.videoWidth;
      this.likedVideosList[index].videoHeight = videoElement.videoHeight;
      this.likedVideosList[index].aspectRatio = videoElement.videoWidth/videoElement.videoHeight;
     
      }      
      this.likedVideosList[index].pausefromScroll = true;
    },
    videoMetaLoadedShared(index,vid){
      var videoElement = document.getElementById("postvideo"+index); 
      if(this.sharedVideosList[index].aspectRatio === null && vid === this.sharedVideosList[index].id ){
        this.sharedVideosList[index].videoWidth = videoElement.videoWidth;
      this.sharedVideosList[index].videoHeight = videoElement.videoHeight;
      this.sharedVideosList[index].aspectRatio = videoElement.videoWidth/videoElement.videoHeight;     
      }      
      this.sharedVideosList[index].pausefromScroll = true;
    },
     LikePostedVideo : function(index, videoId, VideoProfId, sectionType) {
      console.log("videoId : ", videoId)
      console.log("videoprofId : ", VideoProfId)
      console.log("sectionType : ", sectionType)
      var obj = {
        profileId : this.currentUserProfileId,
        videoId : videoId,
        videoProfileId : VideoProfId
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      const fd = new FormData();
      fd.append('userVideoLikes', blob);
      httpuserprofile.post('/userprofile/likeVideo',fd, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then((response) => {
        console.log(response)
        //update posted video like info
        if(sectionType === 'posted') {
          this.postedVideosList[index].likeVideoFlag = 'Y'
          this.postedVideosList[index].listOfLikes = response.data.listOfLikes
          this.postedVideosList[index].noOfLikes = response.data.noOfLikes
          console.log("liked posted video : ", this.postedVideosList[index])
        }
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    
    ShareVideoModal(item, sectionType) {
      //check once
      console.log(this.currentUser)
      item.currentUserProfilepic = this.currentUserProfilePic;
      item.currentUserFirstname = this.currentUser.firstName;
      item.currentUserLastname = this.currentUser.lastName;
      item.currentUserDesignation = this.currentUser.designation.roleName;
      if(sectionType === 'posted') {
        item.videoUserId = this.profileId;
        item.videoUserFirstName = this.firstname;
        item.videoUserLastName = this.lastname;
        item.videoUserProfilePic = this.profilePicLink;
        item.videoUserDesignation = this.userdesignation;
      }
      this.sharevideoobject = item
      this.shareavideomodalopen = true
    },
    closeshareModal() {
      this.shareavideomodalopen = false
    },
    playpostVideo : function(ind, videoId, VideoProfId) {
      var id = "postvideo"+ind;
      var video = document.getElementById(id);
      var video1 = document.getElementsByClassName('postedvideoItem')
      if(this.postedVideosList.length > 0){
        if(this.postedVideosTab) {
          for(var i = 0; i < this.postedVideosList.length; i++) {
            if(i == ind){
              if(!this.postedVideosList[i].isPlaying) {
                video1[i].play()
                this.postedVideosList[i].isPlaying = true
              }else{
                video1[i].pause()
                this.postedVideosList[i].isPlaying = false
              }
            }else{
              video1[i].pause()
              this.postedVideosList[i].isPlaying = false
            }
          }          
        }
      }
      if(this.postedVideosList[ind].viewVideoFlag == 'N') {
        var obj = {
          profileId : this.profileId,
          videoId : videoId,
          videoProfileId : VideoProfId,
          viewed_sec : 0,
          video_type : 'POSTVIDEO'
        }
        var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
        const fd = new FormData();
        fd.append('userVideoViews', blob);
        fd.append("duration", 1)
        httpuserprofile.post('/userprofile/viewVideo',fd, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }).then((response) => {
          console.log(response)
        }).catch((e) => {
          console.log(e)
        })
      }
    },
    VideoPlay  :function(videoitem, index, sectionType) {
      if(sectionType === 'posted'){
        var video = document.getElementById("postvideo"+index);
      }
      // console.log("video tag : ", video)    
      videoitem.videoDuration = video.duration;
      // console.log(videoitem.videoDuration)
      videoitem.videoPaused = false;
      videoitem.pausefromScroll = false;
      var currentTime = videoitem.videoDuration * (50/100);     
      var self= this                         
      video.ontimeupdate = function(){
        if(currentTime < video.currentTime && !videoitem.videoWatched){
          videoitem.videoWatched = true;                      
          self.viewVideo(videoitem);
        }        
      }
      video.onended = function() {
        var nextIndex = index + 1;
        var nextVideo = document.getElementById("selectedUserVideoCardItem"+nextIndex);
        if(nextVideo){
          nextVideo.scrollIntoView()
        }
      }
    },
    VideoPause  :function(videoitem, index, sectionType) {
      var video = document.getElementById("postvideo"+index); 
      console.log(videoitem.pausefromScroll)
      if(!videoitem.pausefromScroll){
        videoitem.videoPaused = true;
      }
    },
    viewVideo: function(video){
      if(video.viewVideoFlag === 'N'){
        console.log("into view function")
        var fd = new FormData(); 
          var obj = {
          profileId : this.profileId,
          videoId: video.id,
          videoProfileId: video.profileId,
          viewed_sec : 0,
          video_type : 'POSTVIDEO'
        }
        var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
        fd.append("userVideoViews", blob)
        fd.append("duration", 1)
        httpuserprofile.post("/userprofile/viewVideo", fd, {
          headers: {
              "Content-Type": "multipart/form-data",
            "Accept" : "*/*"
          }
        })
        .then(response => {
          console.log(response)
          if(response.data.errorCode === 1030){
            video.videoWatched = false
            video.isPlaying = true;
            video.viewVideoFlag = 'Y';
            video.noOfViews = video.noOfViews+1;
          }                           
        }) .catch((e) => {
          console.log(e)
        })       
      }
    },
    videoLoadingPosted(index){
      this.postedVideosList[index].videoLink = null;
    },
    videoLoadingLiked(index){
      this.likedVideosList[index].videoLink = null;
    },
    videoLoadingShared(index){
      this.sharedVideosList[index].videoLink = null;
    },
    unlikePostedVideo : function(index, videoId, sectionType) {
      console.log("unlike videoId : ", videoId)
      httpuserprofile.delete('/userprofile/unLikesVideo?videoId='+videoId+'&profileId='+this.currentUserProfileId)
      .then((response) => {
        console.log(response)
        if(sectionType === 'posted'){
          //update unlike post info
          this.postedVideosList[index].likeVideoFlag = 'N'
          this.postedVideosList[index].noOfLikes = this.postedVideosList[index].noOfLikes - 1
        }
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    openDeleteCommentConfirmationmodal(cmind, comment, videoItem) {
      this.deletecommentconfirmationmodalopen = true;
      this.selectedcommentIndex = cmind;
      this.selectedcommenttodelete = comment;
      this.selectedVideotodeletecomment = videoItem;
    },
    CloseCommentConfirmationModal(deletecommentstatus) {
      console.log("check status 1")
      if(deletecommentstatus == 'SUCCESS'){
        console.log("api call to delete comment video", this.selectedcommentIndex)
        this.deletecommentconfirmationmodalopen = false;
        this.deletepostedVideoComment(this.selectedcommentIndex, this.selectedcommenttodelete, this.selectedVideotodeletecomment)
      }else{
        console.log("cancel delete comment")
        this.deletecommentconfirmationmodalopen = false;
        this.selectedcommentIndex = null;
        this.selectedcommenttodelete = null;
        this.selectedVideotodeletecomment = null;
      }
    },
    deletepostedVideoComment : function(cmind, comment, videoItem) {
      httpuserprofile.delete("/userprofile/deleteCommentOnVideo?commentId="+comment.commentId)
      .then((response) => {
          console.log("delete response : ", response)
          videoItem.listOfComments.splice(cmind, 1)
          videoItem.noOfComments = videoItem.noOfComments-1
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    viewLessComments : function(index, sectionType) {
        var x = this.postedVideosList[index]
        if(x.iscommentsopen){
          x.iscommentsopen = false
        }else{
          x.iscommentsopen = true
        }
        this.postedVideosList[index].limit_by = 3;
    },
    viewAllComments: function(index, sectionType) {
        var x = this.postedVideosList[index]
        console.log(x)
        if(x.iscommentsopen){
          x.iscommentsopen = false
        }else{
          x.iscommentsopen = true
        }
        this.postedVideosList[index].limit_by = this.postedVideosList[index].limit_by+3;
    },
    handleScroll() {
      let scrollPosition = window.scrollY
      this.instanceLoader = false;
      // console.log(scrollPosition)
      if(this.instancedataget  && this.activeClass === 'my_videos') {
        if ((window.innerHeight + window.scrollY+1) >= document.body.offsetHeight) {
          // console.log("last : " + window.scrollY)
          if(this.instancedataget && this.postedVideosList.length > 9) {
            console.log("posted videos scroll load")
            this.postedvideosoffset += 10;
            this.instancedataget = false;
            this.instanceLoader = true;
            console.log(this.instanceLoader)
            this.getPostedVideos()
          }
        }
      }

      var media;
      if(this.postedVideosTab) {
        media = $('.postedvideoItem').not("[autoplay='autoplay']");
        autoplay()
      }
      function autoplay() {
        var tolerancePixel = 100;
        var scrollTop = $(window).scrollTop() + tolerancePixel;
        var scrollBottom = $(window).scrollTop() + $(window).height() - tolerancePixel;
        var playPromise;
        media.each(function(index, el) {
          var yTopMedia = $(this).offset().top;
          var yBottomMedia = $(this).height() + yTopMedia;
          if(scrollTop < yBottomMedia && scrollBottom > yTopMedia){ //view explaination in `In brief` section above                    
            playPromise = $(this).get(0).play();
            if(playPromise !== undefined){
              playPromise.then(_ => {
                $(this).get(0).play();
                // console.log("checktag : ", this)
              })
              .catch(error => {
                // console.log(error)
              });
            }
          } else {
            $(this).get(0).pause();
          }
        });
      }
    },
    postComment : function(index, viditem, sectionType){
      console.log("comment on video : ", viditem)
      var fd = new FormData();
      if(viditem.videoType === 'POST') {
        console.log("post type comment")
        var obj = {
          profileId : this.currentUserProfileId,
          videoId: viditem.id,
          videoProfileId: viditem.profileId,
          comments: viditem.commentpostText
        }
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoComments", blob)
      httpuserprofile.post("/userprofile/commentOnVideo", fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
          if(sectionType === 'posted'){
            console.log("comment posted vid : ", response)
            this.postedVideosList[index].commentpostText = ''
             this.postedVideosList[index].postcommentbtn = false;
             this.postedVideosList[index].commentVideoFlag = 'Y';
            response.data.listOfComments.forEach(function(c){
              c.iscommentchanged = false;
            })
            this.postedVideosList[index].listOfComments = response.data.listOfComments
            this.postedVideosList[index].noOfComments = response.data.noOfComments
          }
          
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    updateComment : function(comment, viditem) {
      console.log("comment : ", comment)
      var fd = new FormData();
      if(viditem.videoType === 'POST') {
        console.log("post type comment")
        var obj = {
          id : comment.commentId,
          profileId : this.currentUserProfileId,
          videoId: viditem.id,
          videoProfileId: viditem.userDetailsVo.profileId,
          comments: comment.comment
        }
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoComments", blob)
      comment.iscommentchanged = false;
      httpuserprofile.put("/userprofile/updateComment", fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
          console.log("comment update response : ", response)
          comment.iscommentchanged = false;
          console.log(comment)
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    closePostMoreActions : function() {
      document.getElementById('postvideomenu').style.display = 'none'
    },
    getEmploymentType : function() {
      httpuserprofile
        .get("searchController/getIndexDetailsList", {
          params: { indexCode: 2 }
        })
        .then(response => {
          this.employmentTypeList = response.data;
          console.log(response.data);
          console.log(this.selectedUser)
          this.getUserByID(this.selectedUser);
          // this.getUserByID()
        });
    },
    DisplayPostCommentUpdate : function(comment){
      console.log(Comment)
      comment.iscommentchanged = true;
    },
    getPostedVideos : function() {
      httpuserprofile.get("/userprofile/postedVideosByProfileId?profileId="+this.profileId+'&limit='+10+'&offset='+this.postedvideosoffset)
      .then((response) => {
        this.contentloader = false;
        console.log(response)
        if(response.data !== "No Posted Videos Found") {
        response.data.forEach(function(d){               
          d.isPlaying = false;
          d.iscommentsopen = false;
          d.moremenuname = 'popover'+d.id;
           d.postcommentbtn = false;
          d.limit_by = 3;
           d.videoDuration = null;
            d.videoWatched =false;
            d.videoPaused = false;
            d.videoWidth == null;
             d.videoHeight = null;
             d.aspectRatio = null;
          if(d.listOfComments.length > 0){
            d.listOfComments.forEach(function(c){
              c.iscommentchanged = false;
            })
          }
               
        })
         this.postedVideosList = this.postedVideosList.concat(response.data);
          this.instancedataget = true;
          this.instanceLoader = false;
        console.log("posted videos list : ", this.postedVideosList)
        }
      }).catch((e) => {
        console.log(e)
        this.contentloader = false;
        this.instancedataget = true;
        this.instanceLoader = false;
      })
    },
    playPorfileVideo(){
      var that = this;
      var video = document.getElementById('profilevideo')
      var totalSec;
      if(video){
        totalSec = Math.round(video.duration)
      }
      console.log(this.$refs)
      if(!this.playingPorfileVideo) {
        this.playingPorfileVideo = true;
        video.play()
        let viewedSec = 0
        this.viewprofileVideo(viewedSec, totalSec)
      }else{
        this.playingPorfileVideo = false;
        video.pause()
        let percent = video.currentTime;
        percent = Math.round(percent)
        this.viewprofileVideo(percent, totalSec)
      }
      video.onended = videoEnded;
      video.oncanplay = stopLoadingLogo;
      video.onwaiting = displayLoadingLogo;
      function videoEnded() {
        that.playingPorfileVideo = true;
        that.replayPorfileVideo = true;
        that.loadingPorfileVideo = false;
        let percent = video.currentTime;
        percent = Math.round(percent)
        that.viewprofileVideo(percent, totalSec)
      }
      function stopLoadingLogo() {
        if(that.playingPorfileVideo){
          that.loadingPorfileVideo = false;
        }
      }
      function displayLoadingLogo() {
        if(that.playingPorfileVideo){
          that.loadingPorfileVideo = true;
        }
      } 
    },
    replayVideo() {
      this.replayPorfileVideo = false;
      this.loadingPorfileVideo = false;
      this.playingPorfileVideo = false;
      this.playPorfileVideo()
    },
    viewprofileVideo: function(viewedSec, totalSec){
        var fd = new FormData(); 
          var obj = {
          profileId : this.currentUserProfileId,
          videoId: this.profileVideoId,
          videoProfileId: this.profileId,
          viewed_sec : viewedSec,
          video_type : 'PROFILEVIDEO'
        }
        console.log("obj : ", obj)
        let videoTotalSec = totalSec
        var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
        fd.append("userVideoViews", blob)
        fd.append("duration", videoTotalSec)
        httpuserprofile.post("/userprofile/viewVideo", fd, {
          headers: {
              "Content-Type": "multipart/form-data",
            "Accept" : "*/*"
          }
        })
        .then(response => {
          console.log(response)                          
        }) .catch((e) => {
          console.log(e)
        }) 
    },
    getUserByID(selectedUser){           
      httpuserprofile
        .get("/userprofile/userbyid/" + selectedUser)
        .then(response => {
          console.log(response)
          this.pageloader = false;
          this.getByIdTotalResponse=response.data;
          this.profileId = response.data.profileId;         
          this.profileVideoId = response.data.profileVideoId;
          //basic info
          this.firstname = response.data.firstName;
          this.lastname = response.data.lastName;


             if(this.getByIdTotalResponse.profilePictureVisibility === 'PUBLIC'){
                  this.profilePicLink = response.data.profilePictureLink;
               }
                if(this.getByIdTotalResponse.profilePictureVisibility === 'PRIVATE'){
                 this.profilePicLink='';
               }

                     
          let aboutyou = response.data.aboutYou;
          if(aboutyou) {
            // this.aboutYou1 = aboutyou.substr(0, 125)
            // this.totalDescription = this.aboutYou1
            // this.aboutYou1 = aboutyou.substr(0, 125)
            // this.aboutYou2 = aboutyou.substr(125)
            this.totalDescription = aboutyou;
          }
          if(response.data.companyDetails){
            this.usercompany = response.data.companyDetails.companyName
          }
          if(response.data.designation){
            this.userdesignation = response.data.designation.roleName
          }
          if(response.data.country){
            this.userdisplayCountry = response.data.country.countryName
          }
          this.jobchange = "N";
          if(response.data.jobChangeStatus){
            this.jobchange = response.data.jobChangeStatus;
          }
          //experience
          this.workExperience = []
           if(response.data.privacy === 'PUBLIC')
         {
          if (response.data.workExperience.length > 0) {
            let experienceList = response.data.workExperience
            for(var i =0; i < experienceList.length; i++){
              for(var j = 0; j < this.employmentTypeList.length; j++){
                if(this.employmentTypeList[j].id == experienceList[i].employeementTypeId) {
                  experienceList[i].employeementTypeString = this.employmentTypeList[j].indexDetailName;
                }
              }
              let descript =  experienceList[i].description; 
              if(descript){
              experienceList[i].description1 = descript.substr(0,196)
              experienceList[i].description2 = descript.substr(196)             
              }      
              console.log(experienceList[i])
               this.workExperience.push(experienceList[i])              
            }
          }
          console.log(this.workExperience)
          //education
          this.educationList = [];
          if(response.data.userEducation.length > 0){
            let education = response.data.userEducation;
            // console.log(education)
            for(var k =0; k < education.length; k++){
              for(var l=0; l < this.typeOfDegreeList.length; l++){
                if(this.typeOfDegreeList[l].id == education[k].typeOfDegreeId) {
                  education[k].typeOfDegreeString = this.typeOfDegreeList[l].indexDetailName
                }
              }
              this.educationList.push(education[k])
            }
          }
          //location
          this.userCountry = response.data.country;
          this.userState = response.data.state;
          this.userCity = response.data.city;
          this.userZipcode = response.data.zipCode;
          this.userWorkAuthorization = response.data.workAuthorization;
          //skills
          this.userKnowledgeList = response.data.userKnowledge;
          this.userTechnologyList = response.data.userTechnology
        }
         if(response.data.privacy === 'PRIVATE')
         {
        this.workExperience='';
        this.educationList='';
         this.userKnowledgeList='';
         this.userCity='';
          this.userCountry = '';
          this.userState='';
          this.userWorkAuthorization='';
          this.userTechnologyList='';
           this.userZipcode ='';
         }
           if(response.data.profileVideoId !== null&& response.data.privacy !== null && response.data.privacy !== undefined && response.data.privacy !== 'PRIVATE') {
            this.getProfileVideo(response.data.profileVideoDetails)
          }else{
            this.getFollowFlagValue(null)
          }
           this.getFollowersList();
          this.getFollowingList();
          this.getPostedVidoesCount();
          this.viewUserProfile()
          // this.getPostedVideos()
        })
    },
    getFollowFlagValue(vidLink) {
      //if video visibility is public we are going to display profile video
      if(this.savedvideovisibility === 'PUBLIC' && vidLink !== null){
        this.savedProfileVideoLink = vidLink;
      }
      // if video visibility is follower we are going to get follow relation and add profile video link
      httpuserprofile
        .get("userprofile/getUsertoUserFollowFlag?profileId="+this.profileId+'&followerId='+this.currentUserProfileId)
        .then(response => {
          console.log("fetch follow flag : ", response)
          let followflag = response.data[0].followingFlag;
          if(followflag == 'Y'){
            this.followingTest = 'UnFollow'
            this.savedProfileVideoLink = vidLink; 
          }else if(followflag == 'N'){
            this.followingTest = 'Follow'
          }
        }).catch((e) => {
          console.log(e)
      })
    },
    getPostedVidoesCount() {
      httpuserprofile
        .get("/userprofile/getCountOfPostedVideos?profileId="+this.profileId)
        .then(response => {
          console.log("post videos count : ", response)
          this.postsCount = response.data.count
        }).catch((e) => {
          console.log(e)
        })
    },
    getProfileVideo(profileviddetails){
      // httpuserprofile.get("/userprofile/getVideoById?videoId="+this.profileVideoId)
      // .then((response) => {
      //   console.log(response)
        console.log("profile video : ", profileviddetails)
        this.totalvideodata = profileviddetails;
        this.savedProfileVideoDate = profileviddetails.creationD
       // this.savedProfileVideoLink = response.data.videoLink;
        this.savedProfileVideoThumbnailLink = profileviddetails.thumbnail;
        this.savedProfileVideoTitle = profileviddetails.videoTitle;
        this.savedProfileVideoDescription = profileviddetails.videoDescription;
        this.savedvideovisibility = profileviddetails.visibility;         
        
        if(this.savedvideovisibility === 'PUBLIC' || this.savedvideovisibility === 'FOLLOWER' || this.savedvideovisibility === 'PRIVATE'){         
          //  this.savedProfileVideoLink = profileviddetails.videoLink;
          this.getFollowFlagValue(profileviddetails.videoLink)
        }      
        if(this.savedvideovisibility === 'PRIVATE'){
         this.savedProfileVideoLink=''

        }
        //  if(this.savedvideovisibility === 'FOLLOWER'){
        //    this.getFollowFlagValue(profileviddetails.videoLink)
        //   // this.getFollowersList()
        // }
      // }).catch((e) => {
      //   console.log(e)
      // })
    },
     readmore : function(){
      this.totalDescription = this.totalDescription.concat(this.aboutYou2)
      this.readmoreclicked = true;
    },
    readless : function() {
      this.readmoreclicked = false;
      this.totalDescription = this.totalDescription.substr(0, 125)      
    },
    readMoreExp  :function(event) {
      let index = event.target.id.substr(8)
      this.workExperience[index].description1 = this.workExperience[index].description1.concat(this.workExperience[index].description2)
      let relessId = "readless"+index
      let id = document.getElementById("totaldescription"+index)
      id.innerHTML = this.workExperience[index].description1;
      document.getElementById(relessId).style.display = 'inline-block'
      document.getElementById(event.target.id).style.display = 'none'
    },
    readLessExp : function(event) {
      let index = event.target.id.substr(8)
      this.workExperience[index].description1 = this.workExperience[index].description1.substr(0, 196)
      let remoreId = "readmore"+index
      let id = document.getElementById("totaldescription"+index)
      id.innerHTML = this.workExperience[index].description1;
      document.getElementById(remoreId).style.display = 'inline-block'
      document.getElementById(event.target.id).style.display = 'none'
    },    
    followUser(){
      console.log(this.selectedUser+'slected')     
      this.disablefollowBtn = true;       
      httpuserprofile
        .post("/userprofile/saveFollowing?profileId="+this.currentUserProfileId+"&followingId="+this.profileId)
        .then(response => {
          if(response.data){            
            this.followingTest ="UnFollow";
            this.disablefollowBtn = false;
            this.followersCount = this.followersCount + 1;
            this.getUserByID(this.selectedUser);
          }                   
        }).catch((e) => {
          console.log(e)
          this.disablefollowBtn = false;
          this.displayAPIerrorModal = true;
        })       
    },
    UnfollowUser(){  
      this.disablefollowBtn = true;   
      httpuserprofile.delete("/userprofile/unfollow?profileId="+this.currentUserProfileId+"&followingId="+this.profileId)
        .then(response => {
          if(response.data){
            console.log(response)
          this.followingTest= 'Follow'
          this.disablefollowBtn = false;
          this.followersCount = this.followersCount - 1;
          this.getUserByID(this.selectedUser);
          }          
        }).catch((e) => {
          console.log(e)
          this.disablefollowBtn = false;
          this.displayAPIerrorModal = true;
        })         
    },
    profileDetails() {     
      this.showprofiledetails = true;
      this.showvideoprofile = false;
      this.showvidoes = false;
    },
    toggleActiveClass(elementId) {
      this.activeClass = elementId;
      if (elementId == "video_profile") {
        this.postedvideosoffset = 0;
        this.videoProfile();
      } else if (elementId == "profile_details") {
        this.postedvideosoffset = 0;
        this.profileDetails();
      } else {
        this.myVideos();
        this.postedVideosTab = true;
        this.contentloader = true;
        this.postedvideosoffset = 0;
        this.postedVideosList = []
        this.getPostedVideos()
      }
    },
    videoProfile() {
      this.showprofiledetails = false;
      this.showvideoprofile = true;
      this.showvidoes = false;
    },
    myVideos() {
      this.showvidoes = true;
      this.showvideoprofile = false;
      this.showprofiledetails = false;
    },
    getFollowersList(){     
      httpuserprofile
        .get("/userprofile/getFollowerUserList?profileId="+this.profileId+'&limit=1&offset=0')
        .then(response => {         
          this.followers = response.data;
          // this.followersCount = response.data.length;
          if(response.data.length > 0){
            this.followersCount = response.data[0].totalrecordsfound;
          }
          // for(var i = 0; i < this.followers.length; i++){            
          //   if(this.currentUserProfileId === this.followers[i].profileId)     {
          //     this.followingTest = 'UnFollow';
          //     this.savedProfileVideoLink = link;     
          //     return;
          //   }
          //   else{
          //     this.followingTest = 'Follow'
          //   }
          // }
        });
    },
    getFollowingList(){
      console.log(this.profileId)
      httpuserprofile
        .get("/userprofile/getFollowingUserList?profileId="+this.profileId+'&limit=15&offset=0')
        .then(response => { 
          // this.followingCount = response.data.length;
          console.log("following user list : ", response)
          if(response.data.length > 0){
            this.followingCount = response.data[0].totalrecordsfound;
          }
        });
    },
    getcurrentUser(){
      httpuserprofile
        .get("/userprofile/userbyid/" + this.currentUserId)
        .then(response => {
          this.currentUser = response.data;
          this.currentUserProfilePic = response.data.profilePictureLink;
          this.currentUserProfileId = response.data.profileId;
          this.currentUserEmail = response.data.email
        }).catch((e) => {
        console.log(e)
      })
    },
    viewUserProfile : function() {
      var vfd = new FormData()
      let obj = { 
        profileId: this.currentUserProfileId,
        userViewedProfileId: this.profileId
      }
      var vblob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      vfd.append("userviewedprofile   ", vblob)
      httpuserprofile.post("/userprofile/userviewedprofile", vfd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
        console.log("successfully viwewed : ", response)
      }).catch((e) => {
        console.log(e)
      })
    }
  },
  created(){
    // this.selectedUser = this.$store.state.selectedUser;
    this.selectedUser = this.$route.params.id;
    console.log()  
    this.currentUserId = sessionUtils.getUserId();
    this.currentUserProfileId = sessionUtils.getUserProfileId()
    this.getcurrentUser();
    this.getEmploymentType();    
    window.addEventListener('scroll', this.handleScroll); 
  }, 
  destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped>
.closebtn1{
  cursor: pointer;
  width: 15px;
  height: 15px;
  margin-top: -3px;
}
.closebtn11:hover{
  background-color: rgba(161, 166, 179,0.3);
  padding-left: 2px;
  border-radius: 50%;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.loadingBgImg1{
    background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 20px 20px;
}
.description2 {
  display: none;
}
.readlesslink {
  display: none;
}
.readmore {
  cursor: pointer;
  color: #0078FF;
  font-size: 14px;
}
.profile-pic {
	position: relative;
	display: inline-block;
}
.edit {
  cursor: pointer;
  border: 1px solid #ced4da;
  border-radius: 50%;
	/* padding-top: 7px;	
	padding-right: 7px; */
	position: absolute;
	right: 0;
	top: 0;
  margin-top:70%
	/* display: none; */
}
.prof-details{
  margin-top: 6px;
}
.circle{
  height: 300px;
  width: 315px;
  border-radius: 50%;
  border:1px solid white;
}
.more_option {
  cursor: pointer;
}
.more_optionmenu{
  padding: 0px 10px 3px 10px;
}
.hover{
  cursor: pointer;
}
#follow{
	transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
    text-align: right;
    /* right: 5%; */
    padding-left : 5px;
  padding-top: 2px;
  /* margin-top: 10px; */
  padding-right: 5px;
  padding-bottom: 2px;
  }
  #follow:hover{
    cursor: pointer;    
  }
  #follow::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 10%;
	right : 10%;
	bottom : 0;
	opacity : 0;
	content : "";
	background-color :  rgba(31,31,31,.3);
  border-radius:20px;
  }
  #follow:hover:before {
    cursor: pointer;
	transition : 0.5s all ease;
	left : 0;
	right : 0;
    padding-left:5px;
	opacity : 1;
	z-index : -1;
    padding-bottom: 5px;    
    padding-right: 5px !important;
    padding-top: 5px !important;
    border-radius:20px;
  }
.more_optionmenu:hover{
  background-color: rgba(161, 166, 179,0.3);
  border-radius: 50%;
  margin-right: -1px;
  border: 1px solid rgba(161, 166, 179,.5);
}
.circle-padding{
   /* padding: 100px 185px 136px 171px; */
   padding-left: 15%  !important;
   padding-top: 6%;
   padding-bottom: 6%;
   text-align:center
}
html,
body,
.grid {
   height: 100%;
  width: 100%;
    /* margin: -.89px; */
}
.grid {
    /* background-image:
      repeating-linear-gradient(#ccc 0 1px, transparent 1px 100%),
      repeating-linear-gradient(90deg, #ccc 0 1px, transparent 1px 100%); */
    background-size: 81px 81px;
     border-radius: 50%;
     overflow: hidden;
}
/* #profImage{
  width: 70px;
  height: 70px;
} */
#profImage1{
  width: 60px;
  height: 60px;
  line-height: 60px;
}
#profImage2{
  width: 40px;
  height: 40px;
  line-height: 40px;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}

.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
  background-color: #f0f2f5;
}
.moreactionsmenu {
  width: 25px;
  padding: 3px;
  border: 1px solid white;
}
.moreactionsmenu:hover{
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 50%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.pending {
  padding: 0px 0px 0px 0px;
}

.nav-link {
  padding: 0px 0px 0px 0px;
}

.card-header {
  border-radius: 8px !important;
}

.nav-tabs {
  border-bottom: none !important;
}

.active {
  border-bottom: 1px red !important;
}

[data-tooltip],
.tooltip {
  position: relative;
  cursor: pointer;
}

.card-img-overlay {
  padding: 0 !important;
}
.pausebtn{
  display: none;
}
.card-img-overlay:hover  .pausebtn{
  display: block;
  margin-left: 45%;
  margin-top: 15%;
  cursor: pointer;
}
.alert-danger1 {
  font-size: 15px !important;
}
.mouseoveraction:hover{
	background-color: rgba(161, 166, 179,.2);
  border-radius: 8px;
}
.black_overlay1 {
  background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%);
  border-radius: 4px 4px 5px 4px;
  padding-bottom: 10px;
}
.black_overlay2 {
  background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%);
  border-radius: 0 4px 5px 4px;
}
.videoheadsection {
  padding-left: 8px !important;
  padding-right: 0px !important;
}
#follower:hover{
  color: #0078ff;
  cursor: pointer;
  text-decoration: underline;
}
/* .card-img-overlay:hover #playvideobtn{
  display: block;
} */
#profilevideo{
  width: 100%;
  border-radius: 4%;
  /* margin-bottom: -10.5px;
  margin-top: -4px; */
}
#postedvideoItem{
  width: 100%;
}
.postvideoIcons {
  cursor: pointer;
}
#resumevideo {
  width: 100%;
  border-radius: 4%;
}
#bottom {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
#playvideobtn {
  /* display: none; */
  /* margin-left: 45%; */
  margin-top: 8%;
  cursor: pointer;
}
.additionalStyles{
  margin-left: 47%;
  margin-top: 9% !important;
}
.pausebtn{
  display: none;
}
.videocard:hover .pausebtn{
  display: block;
  margin-left: 48% !important;
  margin-top: 11% !important;
}
.portraitvideheight{
  height: 500px;
}
.modal-height{
  height: auto;
  margin-top: 5% !important;
  width: 100% !important;
  border-radius: 10px !important;
}

.modal-body{
  background-color: #000000
}
.modal{
  background-color: rgba(31,31,31,.89);
}
.modal-open .modal1 {
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(31,31,31,.8);
}
.modal-open .modal2{
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(31,31,31,.89);
}
.videomodalbody1{
  background-color: rgba(240,242,245,1);
  height: 300px !important;
}
.videomodalbody2 {
  background-color: rgba(240,242,245,.8);
  height: 280px ;
  overflow: auto;
}
.commentssectiontext3{
  background-color: none !important;
}
.addVideoDetails {
  /* height: 205px; */
  margin-top: -5px;
}
/*hide scroll bar */
.videomodalbody2::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.videomodalbody2 {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.videoprofile {
  background-color: white;
  padding: 0 !important;
}
.displayrecorddevcam {
  display: none;
}

.hiderecorddevcam {
  display: block;
}
#vid {
  width: 100%;
  /* margin-left: .20%; */
}
.footer {
  position: fixed;
  bottom: 0;
  z-index: 5;
}
.modalbtn {
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
}
.modalbtn::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  margin-top: -1px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.modalbtn:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.navtoPage {
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
  padding-left : 5px;
  padding-top: 2px;
  /* color: #0078FF !important; */
  /* border: 1px solid #0078FF; */
  /* border-radius: 16px;
  padding-left: 5px !important; */
}
.navtoPage::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.navtoPage:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.modal-footer{
  background-color: #ffffff
}
.red-tooltip + .tooltip > .tooltip-inner {
  background-color: #fff;
  border: 1px solid #fff;
  color: black;
  padding: 15px;
  font-size: 20px;
}
/* Tooltip on bottom */
.test + .tooltip.bottom > .tooltip-arrow {
  border-bottom: 5px solid blue;
}
.compIcon {
  width: 40px;
}
.header {
  position: fixed;
  width: 100%;
  z-index: 4;
  background: #ffffff;
  border-bottom: 2px solid rgba(219, 219, 219,1);
}

.header__content-text {
  text-align: center;
  padding: 15px 20px;
}

.page__content-container {
  margin: 75px auto;
}
/* edit options on video */
.editbtn1 {
  position: absolute !important;
  margin-left: -60px;
  background-color: rgb(240,242,245);
  border: 1px solid blcck;
  color: black;
  right: 0;
  top: 0;
  margin-top: -100px;
  margin-right: 10px;
  z-index: 3;
}
.editbtn1:hover .dropdown-menu{
    display: block;
  }
  .dropdown-menu {
    width: 100px !important;
    min-width: 4rem !important;
    position: absolute;
    right: 0 !important;
  }
.dropdown-menu span{
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding-left: .7em;
  padding-right: .7em;
}
.dropdown-menu span:hover{
  background-color: #ddd;
}
#exampleFormControlFile1 {
  display: none;
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
.instanceloader{
  width: 7%;
  margin-top: 2%;
  margin-left: 48%;
}
#exampleFormControlFile2 {
  display: none;
}
/* #btn_pause_record {
  display: none !important;
}
#btn_resume_record {
  display: none !important;
} */
#videoProfile.vue-popover.dropdown-position-bottom:before{
    display: none;
}
#videoProfile.dropdown-position-bottom {
  left: 55% !important;
  top: 45px !important;
  width: 150px !important;
  padding: 10px 0px 0px 10px !important;
}
#videoResume.dropdown-position-bottom {
  left: 55% !important;
  top: 45px !important;
  width: 150px !important;
  padding: 10px 0px 0px 10px !important;
}
#videoResume.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.profileStrengthpop.dropdown-position-bottom {
  left: 0px !important;
  top: 45px !important;
  width: 300px !important;
  padding: 20px 0px 0px 20px !important;
}

.profileStrengthpop.vue-popover.dropdown-position-bottom:before {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
  top: -6px;
  /* right: 50px; */
  left: 190px !important;
  filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
}
.menuicon {
  cursor: pointer;
}
.moreactionsmenu:hover{
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 50%;
  width: 25px;
  padding: 3px;
  border: 1px solid rgba(161, 166, 179,.5);
}
.welcomemenu.dropdown-position-bottom {
  /* left : 320px  !important; */
  left: 52% !important;
  width: 290px !important;
  top: 30px !important;
  font-size: 14px;
  padding: 0px 0px 0px 00px !important;
}
.welcomemenu.dropdown-position-bottom::before{
  /* left: 235px !important; */
  left: 85% !important;
  display: none;
}
.pendinglist {
  padding-inline-start: 12px !important;
}
/* Notification Actions */
  .dropdown-position-bottom.postvideomenu {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 150px !important;
    left: 79% !important;
  }
  .vue-popover.dropdown-position-bottom.postvideomenu:before {
    display: none !important;
  }
ul li::marker {
  color: #1f1f1f;
  opacity: 0.8;
  font-size: 1.5em;
}

.line {
  display: block;
  height: 1px;
  border: 0;
  padding: 0;
  border: 1px solid #1f1f1f;
  opacity: 0.1;
}
.action {
  cursor: pointer;
}
.action:hover {
  background-color:rgba(221, 223, 229,0.4);
  border-radius: 5px;
}
.line-opacity-4 {
  display: block;
  height: 1px;
  border: 0;
  padding: 0;
  border: 1px solid #1f1f1f;
  opacity: 0.04;
}

.ul-list {
  list-style-type: none;
}
.expDetails {
  white-space: nowrap;
}
.educationDetails {
  white-space: nowrap;
}
.myvideosection {
  overflow: auto;
  white-space: nowrap;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.myvideosection span{
  display: inline-block;
  text-align: center;
  /* padding: 14px; */
  text-decoration: none;
}
.myvideosection::-webkit-scrollbar {
  display: none;
}
.button {
  color: #1f1f1f !important;
}
.close{
  padding: 1px 7px 5px 7px !important;
  /* margin-top: 0px !important; */
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.closebtn {
  cursor: pointer;
  /* width: 20px;
  height: 20px; */
  margin-top: -5px;
  border-radius: 50%;
  padding-left: 3px;
  padding-top: 3px;
}
.closebtnmouseover{
border: 1px solid white;
}
.closebtnmouseover:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 50%;
  /* padding-left: 6px;
  padding-right: 3px; */
  border: 1px solid rgba(161, 166, 179,.5);
}
.contactcard {
  opacity: 0.4 !important;
}

.label-bottom {
  margin-bottom: 0.25rem !important;
  margin-top: 0.25rem !important;
}
/* .addvideobtn:visited img, .addvideobtn:active img{
  background-image: url('../assets/Create_Video.png');
} */
.coloredfont-24 {
  color: #fc597f;
  font-family: "Proxima Nova";
  font-size: 24px;
  font-weight: 300;
}
.proximanova-semibold light-red fontsize12 {
  color: #fc597f;
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 300;
  cursor: pointer;
}
.rerecord{
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
  padding-right: 7px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.rerecord::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  padding-right: 5px;
	background-color :  rgba(31,31,31,.1);
}
.rerecord:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.postedvideoslist{
  padding: 0 !important;
}
.videocardbody {
    position: relative;
    width: 100%;
    height: 100%;
    /* //padding: 20px; */
    background-attachment: scroll;
    overflow: hidden;
    background: black;
}
.videocardbody video {
    min-width: 100%;
    min-height: 100%;
    width: 100%;
    position: relative;
    z-index: 1;
    margin-bottom: -1%;
}
.videocardbody .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    margin-top: 0px !important;
    z-index: 2;
    background: rgba(31, 31, 31, .6);
    /* background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%); */
    /* background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 50%); */
    opacity: 0.5;
    /* margin-top: -5px; */
}
.playpostvideo {
  margin-left: 45%;
  margin-top: 13%;
  cursor: pointer;
}
.muteicon{
  position: absolute;
  background: white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  right: 0;
  bottom: 0;
  margin-right: 2%;
  margin-bottom: 2%;
  cursor: pointer;
}
.muteicon:hover{
  border: 1px solid whitesmoke;
}
.pausebtn1{
  display: none;
}
.overlay:hover .pausebtn1{
  display: block !important;
  margin-left: 45%;
  margin-top: 15%;
  cursor: pointer;
}
/* .videocardbody .overlay1{
  height: 100%;
  width: 100%;
  position: absolute;
  bottom: 0px;
  left: 0px;
  background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%);
  opacity: 0.5;
} */
.horizonline{
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 1px solid #E9EBF0;
}
.horizonline1{
  border-bottom: 1px solid #E9EBF0;
}
.commentssection{
  width: 100%;
}
.postcommenticon{
  margin-right: -5px;
  margin-top: 8px;
  cursor: pointer;
}
.commentssectiontext1{
  width: 70%;
  /* margin-left: 12% !important; */
  padding: 4px;
  padding-left: 8px;
  margin-left: 4%;
  margin-top: 2px;
  border-radius: 15px;
  border: none;
  background-color: #F0F2F5;
  color: rgba(31, 31, 31, .6);
}
.commentssectiontext1:focus{
  outline: none;
  box-shadow: none;
}
.commentssectiontext2{
  width: 80%;
  padding: 4px;
  padding-left: 12px;
  margin-left: 3%;
  border-radius: 0 15px 15px 15px;
  background-color: #F0F2F5;
}
.viewallcomments {
  color: black;
  font-size: 12px;
  cursor: pointer;
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 16px;
  padding-left: 8px !important;
  padding-right: 9px !important;
}
.activeVideoSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.pillbtn:hover {
  background-color: rgba(161, 166, 179,0.1);
  border: 1px solid rgba(161, 166, 179,.5);
  /* font-weight: bold; */
}
svg {
  width: 50px;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.percentageblock {
  padding-right: 0px !important;
  padding-left: 8px !important;
}
.coloredfont-40,
.sub {
  display: flex;
  color: #fc597f;
  font-family: "Proxima Nova";
  font-size: 40px;
  font-weight: 300;
}
.slide-background {
  /* background-color: #f3f4f7; */
  /* background-color: #f5f5f5; */
  background-color: rgba(243, 244, 247, 0.5);
}
.border-tab {
  border-bottom-style: solid;
  border-bottom-color: #0078ff;
}
.proximanova-semibold blue {
  color: #0078FF ;
  font-family: "Proxima Nova";
  /* font-size: 16px; */
  font-weight: bold;
  letter-spacing: 0;
}
.nameblock {
  padding-left: 0 !important;
}
.knowledgeItem { 
  border-radius: 5px;
  cursor: pointer;
  background-color: rgba(231,233,240,.6);
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
.sub {
  font-size: 25px;
}
.count {
  margin-left: 17%;
}
.carousel-control-next,
.carousel-control-prev {
  filter: invert(50%);
}
.carousel-inner {
  width: 270px;
  padding: 1em 2.5em;
}
.carousel-item {
  padding: 20%;
}
.carousel-img {
  width: 30px;
  margin-left: 42%;
}
.pdtext {
  font-size: 13px;
  padding: 0 1em 1em 0;
  text-align: center;
}
.jobSec {
  margin-top: 15% !important;
}
.pendingSec,
.jobSec {
  /* background-color: #e8e9eb; */
  background-color: rgba(161, 166, 179, 0.085);
  border: none;
}
.hr-theme-slash-2 {
  display: flex;
}
.hr-line {
  width: 100%;
  position: relative;
  margin: 15px;
  border-bottom: 1px solid #c5c7c9;
}
.hr-icon {
  position: relative;
  color: #757778;
  font-size: 10px;
  border: 2px solid #c5c7c9;
}
video::-webkit-media-controls-fullscreen-button {
    display: none;
}
@media only screen and (max-width: 600px) {
  #playvideobtn {
  /* display: none; */
  /* margin-left: 45%; */
  margin-top: 14%;
  cursor: pointer;
}
#profImage1{
  width: 40px;
  height: 40px;
  line-height: 40px;
}
.fontsize32{
    font-size: 17px !important;
  }
  .fontsize16{	 
	  font-size: 14px;  	 
}
  .videocardbody video{
    width: 100% !important;
  }
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
  .playpostvideo {
    margin-top: 20%;
  }
  .overlay:hover .pausebtn1{
    margin-top: 25%;
  }
  /* #profImage {
    width : 35px;
    height: 35px;
  } */
  .circle-padding{
   /* padding: 100px 185px 136px 171px; */
    padding-left: 7%  !important;
    padding-top: 6%;
    text-align:center
  }
  .profile-border{
    padding: 0px !important;
  }
  .welcomename {
    margin-top: -7px !important;
    
  }
  .count {
    margin-left: 18%;
  }
  .footer {
    position: fixed;
    bottom: 0;
  }
  .vdtext {
    font-family: "Proxima Nova";
    word-wrap: break-word;
    text-align: center;
    width: 110%;
    padding-left: 0.35em;
  }
  .vdimage {
    height: 35px;
  }
  .pendingSec,
  .jobSec {
    display: none;
  }
  .topmenubar {
    margin-left: 1.5em;
  }
  .profilestrength {
    margin-left: 0px !important;
  }
}
@media screen and (min-width: 600px) {
  .no-video {
    width: 50%;
    align-self: center;
  }
}
@media screen and (max-width: 1440px ) and (min-width: 1024px) {
  .welcomemenu.dropdown-position-bottom {
    left : 48%  !important;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
@media screen and (max-width: 1024px) and (min-width: 769px) {
  .welcomemenu.dropdown-position-bottom {
    left : 29%  !important;
  }
  #videoProfile.dropdown-position-bottom {
    left: 40% !important;
    width: 130px !important;
    padding: 10px 0px 0px 10px !important;
  }
  #videoResume.dropdown-position-bottom {
    left: 40% !important;
    width: 130px !important;
    padding: 10px 0px 0px 10px !important;
  }
}
@media screen and (max-width: 768px) and (min-width: 600px) {
  .footer {
    position: fixed;
    bottom: 0;
  }
}
@media screen and (max-width: 600px) and (min-width: 539px) {
  .welcomemenu.dropdown-position-bottom {
    left : 25%  !important;
  }
  #videoProfile.dropdown-position-bottom {
    left: 45% !important;
    width: 130px !important;
    padding: 10px 0px 0px 10px !important;
  }
  #videoResume.dropdown-position-bottom {
    left: 45% !important;
    width: 130px !important;
    padding: 10px 0px 0px 10px !important;
  }
  .profileStrengthpop.vue-popover.dropdown-position-bottom:before {
    left: 50% !important;
  }
  .dropdown-position-bottom.postvideomenu {
    left: 70% !important;
  }
}
@media screen and (max-width: 539px) and (min-width: 400px) {
  .bold14px_white {
    font-size: 13px !important;
  }
  .bold16px_white {
    font-size: 13px !important;
  }
  .reg16px_white {
    font-size: 13px !important;
  }
  .welcomemenu.dropdown-position-bottom {
    left : 0px  !important;
  }
  #videoProfile.dropdown-position-bottom {
    left: 28% !important;
    width: 130px !important;
    padding: 10px 0px 0px 10px !important;
  }
  #videoResume.dropdown-position-bottom {
    left: 28% !important;
    width: 130px !important;
    padding: 10px 0px 0px 10px !important;
  }
  .profileStrengthpop.vue-popover.dropdown-position-bottom:before {
    left: 45% !important;
  }
  .dropdown-position-bottom.postvideomenu {
    left: 60% !important;
  }
}
@media screen and (max-width: 400px) and (min-width: 350px) {
  .modalbtn{
    padding: .175rem .3rem !important;
  }
  .bold14px_white {
    font-size: 12px !important;
  }
  .bold16px_white {
    font-size: 13px !important;
  }
  .reg16px_white {
    font-size: 13px !important;
  }
  .welcomemenu.dropdown-position-bottom {
    left : -40px  !important;
  }
  #videoProfile.dropdown-position-bottom {
    left: 20% !important;
    width: 130px !important;
    padding: 10px 0px 0px 10px !important;
  }
  #videoResume.dropdown-position-bottom {
    left: 20% !important;
    width: 130px !important;
    padding: 10px 0px 0px 10px !important;
  }
  .profileStrengthpop.vue-popover.dropdown-position-bottom:before {
    left: 50% !important;
  }
  .dropdown-position-bottom.postvideomenu {
    left: 55% !important;
  }
}
@media screen and  (max-width: 1030px){
  .displayrecorddevcam {
    display: block;
  }
  .hiderecorddevcam {
    display: none;
  }
}
@media screen and (max-width: 350px) and (min-width: 300px) {
  .thumbnailtext{
    display: none;
  }
  .videomodalbody2{
    height: 350px !important;
  }
  .rerecord{
    padding: 0px !important;
  }
  .modalbtn{
    padding: .175rem .37rem !important;
  }
  .profileStrengthpop.vue-popover.dropdown-position-bottom:before {
    left: 45% !important;
  }
  #videoProfile.dropdown-position-bottom {
    left: 10% !important;
    width: 130px !important;
    padding: 8px 0px 0px 8px !important;
  }
  #videoResume.dropdown-position-bottom {
    left: 10% !important;
    width: 130px !important;
    padding: 8px 0px 0px 8px !important;
  }
  .bold14px_white {
    font-size: 12px !important;
  }
  .bold16px_white {
    font-size: 13px !important;
  }
  .reg16px_white {
    font-size: 13px !important;
  }
  .coloredfont-40{
    font-size: 30px;
  }
  .sub {
    font-size: 20px !important;
    margin-top: 9px !important;
  }
  .welcomemenu.dropdown-position-bottom {
    left : -30%  !important;
  }
  .dropdown-position-bottom.postvideomenu {
    left: 50% !important;
  }
}
@media screen and (max-width: 300px) {
  .welcomemenu.dropdown-position-bottom {
    left : -30%  !important;
  }
  .dropdown-position-bottom.postvideomenu {
    left: 40% !important;
  }
}
</style>